export const MIDDLEWARE_ACCESS_TOKEN_KEY = "iris_token";
export const MIDDLEWARE_REFRESH_TOKEN_KEY = "iris_refresh_token";
export const MIDDLEWARE_EXPIRY_TIME = "iris_token_expiry_time";

export const MIDDLEWARE_LOGGING_IN_FLAG = "logging_in_middleware";
